async function prepareJSON(obj) {
    try {
        return JSON.parse(obj); // Bezpieczne parsowanie JSON
    } catch (error) {
        console.error("Error parsing JSON", error);
        return null; // Zwróć null, jeśli parsowanie się nie powiedzie
    }
}

async function createModalContent(obj) {
    if (!obj) {
        return ''; // Zwróć pusty ciąg, jeśli obiekt jest null lub niepoprawny
    }

    const title = obj.heading;
    const description = obj.description;
    const projectValue = obj.project_value ?? '';
    const eu_refund = obj.eu_refund ?? '';
    const { src, width, height } = obj.photo;

    const content = `<div class="modal-content">
        <h4 class="title">${title}</h4>
        <div class="description">${description}</div> <!-- Poprawiony brakujący = -->
        <div class="modal-content__bottom">
            <div class="image">
                <img src="${src}" width="546" height="352" loading="lazy"/>
            </div>
            <div class="content">
                <div class="content-item">
                    <div><b>Wartość projektu: </b>${projectValue}</div>
                </div>
                <div class="content-item">
                    <div><b>Wartość dofinansowania <br/>z Funduszy Europejskich:  </b> 
                    ${eu_refund}
                    </div>
                </div>
            </div>
        </div>
        </div>`;

    return content;
}

async function addContentToModal(el, content) {
    el.innerHTML = content;
}

async function openModal(el) {
    el.classList.remove('hidden');
}

function modalClose(el) {
    el?.classList.add('hidden');
    el.querySelector('.modal__content').innerHTML = '';
}

const sliderModal = () => {    
    const modalBtns = document.querySelectorAll('.btn-more');
    const closeBtn = document.querySelector('.modal:not(.modal-video) .btn-close');
    const modal = document.querySelector('.modal:not(.modal-video)');
    
    [...modalBtns].forEach((btn) => {
        btn.addEventListener('click', async (e) => { // Dodano async, aby obsługiwać asynchroniczność
            e.preventDefault();
            const el = btn.closest('.splide__slide');
            const dataObj = el.dataset.modal;
            const modal = document.querySelector('.modal:not(.modal-video) .modal__content');
            const popup = document.querySelector('.modal:not(.modal-video)');

            const parsedData = await prepareJSON( dataObj ); // Czekaj na wynik parsowania
            const modalContent = await createModalContent( parsedData ); // Tworzenie treści modala
            await addContentToModal(modal, modalContent); // Dodaj treść do modala
            await openModal(popup);
        });
    });

   closeBtn && closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        modalClose(modal);
    });


    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.classList.contains("hidden")) {
          modalClose(modal);
        }
    });
};

export default sliderModal;